var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wg8z2mbkea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/user",
    style: {
      clipPath: "url(#wg8z2mbkea)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/user (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.032 12.442h-.82a.108.108 0 0 1-.11-.107 4.1 4.1 0 0 0-8.2 0 .109.109 0 0 1-.109.107h-.824a.11.11 0 0 1-.043-.008.117.117 0 0 1-.036-.025.121.121 0 0 1-.024-.036.109.109 0 0 1-.006-.043 5.124 5.124 0 0 1 1.505-3.522 5.107 5.107 0 0 1 1.634-1.1h.017a3.391 3.391 0 1 1 3.971 0h.016a5.138 5.138 0 0 1 3.139 4.625.109.109 0 0 1-.007.043.1.1 0 0 1-.024.036.106.106 0 0 1-.036.025.108.108 0 0 1-.043.005zM7.001 2.598a2.354 2.354 0 1 0 1.659.689 2.334 2.334 0 0 0-1.659-.689z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIconBlack);
export default __webpack_public_path__ + "static/media/avatarIcon_black.e4c753bd2027dfe37fee0045dfe33397.svg";
export { ForwardRef as ReactComponent };